import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

export const FONT_OPTIONS = [
  "Bebas Neue",
  "Anton",
  "Oswald",
  "Teko",
  "Archivo Black",
  "Bungee",
  "Russo One",
  "Staatliches",
];

function loadFont(name) {
  const family = name.replace(/\s+/g, "+");
  const id = `gf-${family}`;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${family}:wght@400;700&display=swap`;
  document.head.appendChild(link);
}

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({ hero_image_url: "", heading_font: "Bebas Neue", hero_images: [], slideshow: false, divisions: ["Open", "35 Over", "40 Over", "45 Over"], hero_fit: "cover", announcements: [], music_url: "", music_enabled: false, music_tracks: [], payments: { enabled: false, instructions: "", zelle: { enabled: false, label: "", qr_url: "" }, venmo: { enabled: false, label: "", qr_url: "" } }, social: { facebook: "", instagram: "", tiktok: "" } });

  const applyFont = useCallback((font) => {
    if (!font) return;
    loadFont(font);
    document.documentElement.style.setProperty("--display-font", `'${font}'`);
  }, []);

  const load = useCallback(() => {
    api.get("/settings").then((r) => {
      setSettings(r.data);
      applyFont(r.data.heading_font);
    }).catch(() => {});
  }, [applyFont]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => { FONT_OPTIONS.forEach(loadFont); }, []);

  const value = useMemo(() => ({ settings, setSettings, reloadSettings: load, applyFont }), [settings, load, applyFont]);

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
